import React from 'react';
import { Popover, PopoverContainer, usePopoverState } from '../popover/index.js';
import { SideNavItem } from './side-nav-item.js';
/**
 * SideNavItemTooltip
 * - Intermediate component that wraps Popover to display labels on collapsed+persistent SideNav.
 * - This component is not exported and should not be used directly by consumers.
 * - It will be removed in a future TDS version, whenever Tooltip receives it's full refactor in AWSM-8656.
 */
export const SideNavItemTooltip = ({ item }) => {
    const { open, triggerHandlers, containerRef, popoverRef } = usePopoverState({
        openOnHover: true,
    });
    // In this case Popover should be _only_ sensitive to hover as click navigates the user
    const { onMouseEnter, onFocus } = triggerHandlers;
    return (React.createElement(PopoverContainer, { anchorSide: "inline-end", containerRef: containerRef },
        React.createElement(SideNavItem, { ...item, onMouseEnter: onMouseEnter, onFocus: onFocus }),
        React.createElement(Popover, { open: open, popoverRef: popoverRef },
            React.createElement("strong", null, item.leadingText))));
};
